var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news-tags" }, [
    _vm.companies.length
      ? _c(
          "div",
          { staticClass: "common-space common-space-horizontal fx-wrap mb-5" },
          _vm._l(_vm.companies, function (item, i) {
            return _c(
              "div",
              { key: i, staticClass: "common-space--item mr-10 mb-5" },
              [
                _c(
                  "span",
                  { staticClass: "news-tag is-company company-tag is-active" },
                  [
                    _c("span", [_vm._v(_vm._s(item.name))]),
                    _vm.data.sensitivity
                      ? _c(
                          "span",
                          {
                            staticClass: "common-positive-negative mr-8",
                            class: ["is-" + _vm.data.sensitivity],
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.sentiment(item.pos)) +
                                  " " +
                                  _vm._s(_vm.thePercent)
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "common-space common-space-horizontal fx-wrap" },
      _vm._l(_vm.tagsList, function (item, i) {
        return _c(
          "div",
          { key: i, staticClass: "common-space--item mr-8 mb-4" },
          [
            _c("span", { staticClass: "news-tag", class: item.classify }, [
              _vm._v(_vm._s(item.itemName)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }